<ng-container *ngIf="data$ | async"></ng-container>
<ng-container *ngIf="integrations$ | async"></ng-container>

<div class="course-archive-progress">
  <div class="course-archive-progress-top-row">
    <h2>Archive Status</h2>
    <div class="course-archive-progress-top-row-buttons-container">
      <button
        [disabled]="batchDetailsService.isDownloadingCSV"
        *ngIf="showDownload"
        nbButton
        ghost
        (click)="downloadCsv()"
        class="text-link-color course-archive-progress-button"
      >
        <span class="text-link-color">
          <i class="fa-light fa-file-export"></i>
        </span>
        Download CSV
      </button>
      <button
        *ngIf="showBatchDetails"
        (click)="navigateToBatchDetails()"
        nbButton
        ghost
        class="text-link-color course-archive-progress-button"
      >
        <span class="text-link-color">
          <i class="fa-light fa-boxes-stacked"></i>
        </span>
        Batch Details
      </button>
      <button
        [nbTooltip]="pausedTooltipText"
        [disabled]="!integrations?.length || isLoading || areAllUpdating"
        *ngIf="showPause || integrations?.length"
        (click)="openPauseImportsModal()"
        nbButton
        ghost
        class="text-link-color course-archive-progress-button"
      >
        <span *ngIf="!areAllPaused" class="text-link-color">
          <i class="fa-light fa-circle-pause"></i>
        </span>
        <span *ngIf="areAllPaused" class="text-link-color">
          <i class="fa-light fa-circle-play"></i>
        </span>
        {{ pauseButtonText }}
      </button>
    </div>
  </div>
  <div class="course-archive-progress-chart-containers">
    <scaffold-course-archive-progress-donut-chart
      [hasError]="hasError"
      [isLoading]="isLoading"
      [data]="data"
      [field]="'queued'"
    ></scaffold-course-archive-progress-donut-chart>
    <scaffold-course-archive-progress-donut-chart
      [hasError]="hasError"
      [isLoading]="isLoading"
      [data]="data"
      [field]="'failed'"
    ></scaffold-course-archive-progress-donut-chart>
    <scaffold-course-archive-progress-donut-chart
      [hasError]="hasError"
      [isLoading]="isLoading"
      [data]="data"
      [field]="'not_found'"
    ></scaffold-course-archive-progress-donut-chart>
    <scaffold-course-archive-progress-donut-chart
      *ngIf="showSkipped"
      [hasError]="hasError"
      [isLoading]="isLoading"
      [data]="data"
      [field]="'skipped'"
    ></scaffold-course-archive-progress-donut-chart>
    <scaffold-course-archive-progress-donut-chart
      [hasError]="hasError"
      [isLoading]="isLoading"
      [data]="data"
      [field]="'processing'"
    ></scaffold-course-archive-progress-donut-chart>

    <scaffold-course-archive-progress-donut-chart
      [hasError]="hasError"
      [isLoading]="isLoading"
      [data]="data"
      [field]="'complete'"
    ></scaffold-course-archive-progress-donut-chart>
  </div>
</div>
